import { useEffect, useState } from "react";

import MainLayout from "../layouts/MainLayout";
import HomeHeader from "../containers/HomeHeader";
import FeatureLayout from "../layouts/FeatureLayout";
import InsurranceListShowcase from "../components/InsurranceListShowcase";
import ArticleListShowcase from "../components/ArticleListShowCase";
import Footer from "../containers/Footer";

import { Button, Col, Row, Card } from "react-bootstrap";
import { fetchInsurrances, fetchArticles } from "../apis";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// For animations
import { Fade, Slide, Zoom } from "react-awesome-reveal";
import { motion } from "framer-motion";
import styled from "styled-components";

// Get the current language selected
// import { currentLanguage } from "../utilities/I18nLangConfig";
import cookies from "js-cookie";

const Headinglayout = styled.h2({
  fontSize: '5.4rem',
  fontWeight: '800',
  color: '#1e293b',
  textTransform: 'capitalize',
  letterSpacing: '-0.025em',
  display: 'inline-block',
  lineHeight: '1.12',
  width: '75%',
  '@media only screen and (max-width: 81.25em)': {
    width: '90%',
    fontSize: '5rem'
  },
  '@media only screen and (max-width: 37.5em)': {
    width: '95%',
    fontSize: '3.8rem'
  }
});

function Home() {
  const { t } = useTranslation();

  const [insurrances, setInsurrances] = useState(null);
  const [articles, setArticles] = useState(null);

  const history = useNavigate();

  const onFetchInsurrances = async () => {
    const langCode = cookies.get("i18next");
    try {
      const json = await fetchInsurrances(true, langCode);
      if (json) {
        setInsurrances(json);
      }
    } catch (error) {
      console.error("Failed to fetch insurrances:", error?.response?.data ?? error.message);
    }
  };

  const onFetchArticles = async () => {
    const langCode = cookies.get("i18next");
    try {
      const json = await fetchArticles(true, langCode);
      if (json && json.length > 0) {
        setArticles(json);
      }
    } catch (error) {
      console.error("Failed to fetch articles:", error?.response?.data ?? error.message);
    }
  };

  useEffect(() => {
    onFetchInsurrances();
    onFetchArticles();
  }, [t]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <MainLayout pageCSS={"home-page"}>
        <HomeHeader />

        {/* Stats strip */}
        <div className="home-page__stats">
          <div className="container">
            <div className="home-page__stats-grid">
              <div className="home-page__stats-item">
                <span className="home-page__stats-number">500+</span>
                <span className="home-page__stats-label">{t("home_stats_clients")}</span>
              </div>
              <div className="home-page__stats-item">
                <span className="home-page__stats-number">CIMA</span>
                <span className="home-page__stats-label">{t("home_stats_certified")}</span>
              </div>
              <div className="home-page__stats-item">
                <span className="home-page__stats-number">2015</span>
                <span className="home-page__stats-label">{t("home_stats_since")}</span>
              </div>
              <div className="home-page__stats-item">
                <span className="home-page__stats-number">7+</span>
                <span className="home-page__stats-label">{t("home_stats_products")}</span>
              </div>
            </div>
          </div>
        </div>

        {/* This component displays the list of Insurrances  */}
        <FeatureLayout
          title={t("home_feature_layout-insurrance-breadcrumb-title")}
        >
          <div className="text-center">
            <Zoom triggerOnce duration={1500}>
              <Headinglayout className="u-mt-medium u-mb-big">
                {t("home_feature_layout-insurrance-heading-title")}
                <span className="text-gradient-primary">
                  {t("home_feature_layout-insurrance-heading-title-focus")}
                </span>
              </Headinglayout>
            </Zoom>
            <div className="u-mt-medium list-showcase">
              <InsurranceListShowcase items={insurrances} lg={4} />
            </div>
            <Button
              className="btn-blue btn-shadow u-mt-medium"
              onClick={() => history("/insurrances")}
            >
              {t("see-more_button")}
            </Button>
          </div>
        </FeatureLayout>

        {/* This component displays the the about us section  */}
        <FeatureLayout
          title={t("home_feature_layout-aboutUs-breadcrumb-title")}
          extracss="bg-gray"
        >
          <Row className="u-mt-big home-page__about-us">
            <Col lg={6}>
              <Zoom triggerOnce>
                <Headinglayout className="u-mb-medium">
                  {t("home_feature_layout-aboutUs-heading-title")}
                     <span className="text-gradient-primary">
                      {t("home_feature_layout-aboutUs-heading-title-focus")}
                    </span>
                </Headinglayout>
              </Zoom>
              <Fade cascade direction="left" triggerOnce>
                <p className="secondary-text u-mb-medium">
                  {t("home_feature_layout-aboutUs-secondary-text-third")}
                </p>
                <p className="secondary-text u-mb-medium">
                  {t("home_feature_layout-aboutUs-secondary-text-fourth")}
                </p>
              </Fade>
              <Button
                className="btn-blue btn-shadow u-mt-medium"
                onClick={() => history("/about")}
              >
                {t("know-more_button")}
              </Button>
            </Col>

            <Col
              lg={6}
              style={{
                backgroundImage: `url(https://res.cloudinary.com/dnfpmrdjl/image/upload/v1659738189/about-us_wmutss.png)`,
                backgroundSize: "cover",
                backgroundPosition: "top",
              }}
            ></Col>
          </Row>
        </FeatureLayout>

        {/* This section presents the online-services section  */}
        <FeatureLayout
          title={t("home_feature_layout-online-services-breadcrumb-title")}
        >
          <Zoom triggerOnce duration={1500} className="text-center">
            <Headinglayout className="u-mt-medium u-mb-medium">
              <span className="text-gradient-primary">
                {t("home_feature_layout-online-services-title-focus")}
              </span>
              {t("home_feature_layout-online-services-heading-title")}
            </Headinglayout>
          </Zoom>
          <Row className="u-mt-medium home-page__invoices">
            <Col
              lg={6}
              style={{
                backgroundImage: `url(https://res.cloudinary.com/dnfpmrdjl/image/upload/v1660330828/bill_jfpoek.jpg)`,
                backgroundSize: "cover",
                backgroundPosition: "top",
                // boxShadow: "0 0rem 0rem rgba(36, 36, 36, 0.2)",
                borderRadius: "5px",
              }}
            ></Col>
            <Col lg={6} className="home-page__invoices-text-section">
              <Slide direction="right" triggerOnce>
                <p className="secondary-text text-justify u-mb-medium">
                  {t("home_feature_layout-online-services-secondary-header")}
                </p>
                <Card className="secondary-text text-justify">
                  <Card.Title>
                    {t("home_feature_layout-online-services-invoice-header")}
                  </Card.Title>
                  <Card.Body className="">
                    {t("home_feature_layout-online-services-invoice-content")}
                  </Card.Body>
                  <Link to="online-services/invoices">
                    {t("home_feature_layout-online-services-click-button")}
                  </Link>
                </Card>
                <Card className="u-mt-small secondary-text u-mb-medium">
                  <Card.Title>
                    {t("home_feature_layout-online-services-claim-header")}
                  </Card.Title>
                  <Card.Body className="">
                    {t("home_feature_layout-online-services-claim-content")}
                  </Card.Body>
                  <Link to="online-services/claim-report">
                    {t("home_feature_layout-online-services-click-button")}
                  </Link>
                </Card>
              </Slide>

              <div className="home-page__invoices-text-section-button">
                <Button
                  className="btn-blue btn-shadow"
                  onClick={() => history("/online-services")}
                >
                  {t("see-more_button")}
                </Button>
              </div>
            </Col>
          </Row>
        </FeatureLayout>

        {/* This component displays the list of Articles(Blog)  */}
        <FeatureLayout
          title={t("home_feature_layout-article-breadcrumb-title")}
          extracss="bg-gray"
        >
          <div className="text-center">
            <Zoom triggerOnce duration={1500}>
              <Headinglayout className="u-mt-medium u-mb-medium">
                {t("home_feature_layout-article-heading-title")}
                <span className="text-gradient-primary">
                  {t("home_feature_layout-article-heading-title-focus")}
                </span>
              </Headinglayout>
            </Zoom>
            <ArticleListShowcase articles={articles} />
            {articles ? (
              <Button
                className="btn-blue btn-shadow u-mt-medium"
                onClick={() => history("/blog")}
              >
                {t("see-more_button")}
              </Button>
            ) : (
              ""
            )}
          </div>
        </FeatureLayout>
        <Footer />
      </MainLayout>
    </motion.div>
  );
}

export default Home;
